import {Injectable, NgModule} from '@angular/core';
import {Config} from './config.service';

@Injectable()
export class MockConfigService implements Config {
  gatewayUrl = 'http://not-a-real-server';
  taxGatewayUrl = 'http://not-a-real-tax-server';
  identityBaseUrl: string;
  identityClientId: string;
  identityScope: string;
  identityRedirectUri: string;
  identityLogoutRedirectUri: string;
  authenticationEnabled: boolean;
  verifyTokens: boolean;
  entitlementsEnabled: boolean;
  verifyReferrer: boolean;
  identityEnabled: boolean;
  gatewayExternalPageKey = 'PaymentServices.Ssp';
  taxGatewayExternalPageKey = 'PaymentServices.Tax.Api';
  externalUrlPrefix = 'handlers/ExternalServicesProxy.ashx';
  launchDarkly = {
    clientSideId: '',
    enabled: false,
    user: {
      key: '',
      secondaryKey: '',
      ip: '',
      email: '',
      name: '',
      avatar: '',
      firstName: '',
      lastName: '',
      country: '',
      anonymous: false,
      customAttributes: undefined
    }
  };

  init() {
  }

  private getConfig(): Config {
    return this;
  }
}

@NgModule({
  providers: [MockConfigService],
})
export class MockConfigModule {
}
